import React from 'react';
import {
  Redirect, Route, Switch,
} from 'react-router-dom';
import ReassignEID from '../pages/reassigneId';
import UserInfo from '../pages/userInfo';

function LightUserRoute() {
  return (
    <Switch>
      <Route exact path="/reassign-eid" name="ReassigneId" component={ReassignEID} />
      <Route exact key="my-profile" path="/my-profile" name="UserInfo" component={UserInfo} />
      <Redirect from="/" to="/reassign-eid" />
    </Switch>
  );
}

export default LightUserRoute;
